import InlineSVG from 'svg-inline-react'
import cx from 'classnames'

import './style.styl'

export const TargetingOption = ({ iconSrc, isSelected, handleClick, label, description }) => (
  <div className={cx('playbook-targeting-choice-card', { selected: isSelected })} onClick={handleClick}>
    <InlineSVG src={iconSrc} />
    <div className="playbook-targeting-choice-meta">
      <div className="playbook-targeting-choice-label">{label}</div>
      <div className="playbook-targeting-choice-description">{description}</div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingOption/component.js